import type { ICompanyMSServiceNote } from './../types/note/models'
import { makeNoteService } from '~/cynqueModules/factoriesForServices/notes'

export const {
  createNote: createCompanyMSServiceNote,
  updateNote: updateCompanyMSServiceNote,
  deleteNote: deleteCompanyMSServiceNote,
} = makeNoteService<ICompanyMSServiceNote>(
  '/api/companymsservicenotes',
  'companyMSServiceNote'
)
